import { Images, ImagesMobile } from '@/assets/images';
import { ROUTERS, RoutesCodeEnum, RoutesNameEnum } from '@/constant';
import { ReactNode } from 'react';

import type { MenuProps } from 'antd';
import { isNilOrEmpty, isNotNilOrEmpty } from 'ramda-adjunct';

type MenuItem = Required<MenuProps>['items'][number];

export interface LevelKeysProps {
	key: string;
	label: string;
	children?: LevelKeysProps[];
}

export const findObjectNestedArray = (data: LevelKeysProps[], key: string) => {
	if (isNilOrEmpty(data)) return undefined;
	for (const parentObject of data) {
		const item = parentObject?.children?.find((item) => item?.key === key);
		if (item) {
			return parentObject;
		}
	}
	return undefined;
};

const getItem = (
	key: string,
	label: string | ReactNode,
	icon?: ReactNode,
	children?: MenuItem[]
): MenuItem => {
	return {
		key,
		label,
		// icon,
		children,
	};
};

const getItemMobile = (
	key: string,
	label: string | ReactNode,
	icon?: string
): MenuItem => {
	return {
		key,
		label,
		icon,
	};
};

const getSystemMenuItems = () => [
	getItem(
		ROUTERS.UM1_01,
		RoutesCodeEnum.UM1_01,
		<img src={Images.iconDashboard} />
	),
	getItem(
		RoutesCodeEnum.SUB_CM,
		RoutesCodeEnum.SUB_CM,
		<img src={Images.iconBusiness} />,
		[
			getItem(
				ROUTERS.CM1_01,
				RoutesCodeEnum.CM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.CM2_01,
				RoutesCodeEnum.CM2_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),

	getItem(
		RoutesCodeEnum.SUB_NOTICE_INQUIRY_BOARD,
		RoutesCodeEnum.SUB_NOTICE_INQUIRY_BOARD,
		<img src={Images.iconOperations} />,
		[
			getItem(
				ROUTERS.NM1_01(ROUTERS.SUB_SYSTEM_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.NM1_01,
				<img src={Images.iconOperations} />
			),
			getItem(
				ROUTERS.BBM1_01(ROUTERS.SUB_SYSTEM_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.BBM1_01,
				<img src={Images.iconOperations} />
			),
		]
	),

	getItem(
		ROUTERS.SM1_01,
		RoutesCodeEnum.SM1_01,
		<img src={Images.iconOperations} />
	),

	getItem(
		ROUTERS.AU1_01(ROUTERS.SYSTEM),
		RoutesCodeEnum.AU1_01,
		<img src={Images.iconOperations} />
	),
];

const getWorkerMenuItems = () => [
	getItem(
		ROUTERS.ED1_01,
		RoutesCodeEnum.ED1_01,
		<img src={Images.iconDashboard} />
	),
	getItem(
		RoutesCodeEnum.SUB_WORKER_BASIC_INFO,
		RoutesCodeEnum.SUB_WORKER_BASIC_INFO,
		<img src={Images.iconBasicInfo} />,
		[
			getItem(
				ROUTERS.FM1_01,
				RoutesCodeEnum.FM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.US1_01,
				RoutesCodeEnum.US1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.MM1_01,
				RoutesCodeEnum.MM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
	getItem(
		ROUTERS.AR1_01,
		RoutesCodeEnum.AR1_01,
		<img src={Images.iconWorker} />
	),
	getItem(
		ROUTERS.FR1_01,
		RoutesCodeEnum.FR1_01,
		<img src={Images.iconBusinessSite} />
	),
	getItem(
		ROUTERS.RM1_01,
		RoutesCodeEnum.RM1_01,
		<img src={Images.iconReferrer} />
	),
	getItem(
		ROUTERS.LM1_01,
		RoutesCodeEnum.LM1_01,
		<img src={Images.iconAccommodation} />
	),
	getItem(
		RoutesCodeEnum.SUB_PM,
		RoutesCodeEnum.SUB_PM,
		<img src={Images.iconProgram} />,
		[
			getItem(
				ROUTERS.PM1_01,
				RoutesCodeEnum.PM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.PM2_01,
				RoutesCodeEnum.PM2_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
	getItem(
		RoutesCodeEnum.SUB_AM,
		RoutesCodeEnum.SUB_AM,
		<img src={Images.iconAssignment} />,
		[
			getItem(
				ROUTERS.AM1_01,
				RoutesCodeEnum.AM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.AM3_01,
				RoutesCodeEnum.AM3_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
	getItem(
		RoutesCodeEnum.SUB_PA,
		RoutesCodeEnum.SUB_PA,
		<img src={Images.iconAssignment} />,
		[
			getItem(
				ROUTERS.PA1_01,
				RoutesCodeEnum.PA1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.PA2_01,
				RoutesCodeEnum.PA2_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.PA3_01,
				RoutesCodeEnum.PA3_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.PA4_01,
				RoutesCodeEnum.PA4_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
	getItem(
		ROUTERS.WC1_01,
		RoutesCodeEnum.WC1_01,
		<img src={Images.iconDocument} />
	),
	getItem(
		ROUTERS.BM1_01,
		RoutesCodeEnum.BM1_01,
		<img src={Images.iconUnauthorizedDeparture} />
	),
	getItem(
		ROUTERS.DM1_01,
		RoutesCodeEnum.DM1_01,
		<img src={Images.iconChangeOfWorkplace} />
	),
	getItem(
		RoutesCodeEnum.SUB_NOTICE_INQUIRY_BOARD,
		RoutesCodeEnum.SUB_NOTICE_INQUIRY_BOARD,
		<img src={Images.iconOperations} />,
		[
			getItem(
				ROUTERS.NP1_01(ROUTERS.SUB_WORKER_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.NP1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.BB1_01(ROUTERS.SUB_WORKER_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.BB1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.NM1_01(ROUTERS.SUB_WORKER_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.NM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.BBM1_01(ROUTERS.SUB_WORKER_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.BBM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
	getItem(
		ROUTERS.ST1_01,
		RoutesCodeEnum.ST1_01,
		<img src={Images.iconOperations} />
	),
	getItem(
		ROUTERS.WH1_01,
		RoutesCodeEnum.WH1_01,
		<img src={Images.iconOperations} />
	),
	getItem(
		ROUTERS.AU1_01(ROUTERS.WORKER),
		RoutesCodeEnum.AU1_01,
		<img src={Images.iconOperations} />
	),
	getItem(
		RoutesCodeEnum.SUB_DEV,
		RoutesCodeEnum.SUB_DEV,
		<img src={Images.iconProgram} />,
		[
			getItem(
				ROUTERS.DEV_01,
				RoutesCodeEnum.DEV_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.DEV_03,
				RoutesCodeEnum.DEV_03,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.DEV_08,
				RoutesCodeEnum.DEV_08,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
];

const getForeignMenuItems = () => [
	getItem(
		ROUTERS.OD1_01,
		RoutesCodeEnum.OD1_01,
		<img src={Images.iconDashboard} />
	),
	getItem(
		RoutesCodeEnum.SUB_FOREIGN_BASIC_INFO,
		RoutesCodeEnum.SUB_FOREIGN_BASIC_INFO,
		<img src={Images.iconBusiness} />,
		[
			getItem(
				ROUTERS.OI1_01,
				RoutesCodeEnum.OI1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.OI2_01,
				RoutesCodeEnum.OI2_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
	getItem(
		ROUTERS.OR1_01,
		RoutesCodeEnum.OR1_01,
		<img src={Images.iconOperations} />
	),
	getItem(
		ROUTERS.OP1_01,
		RoutesCodeEnum.OP1_01,
		<img src={Images.iconOperations} />
	),
	getItem(
		RoutesCodeEnum.SUB_NOTICE_INQUIRY_BOARD,
		RoutesCodeEnum.SUB_NOTICE_INQUIRY_BOARD,
		<img src={Images.iconCSM} />,
		[
			getItem(
				ROUTERS.NP1_01(ROUTERS.SUB_FOREIGN_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.NP1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.BB1_01(ROUTERS.SUB_FOREIGN_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.BB1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.NM1_01(ROUTERS.SUB_FOREIGN_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.NM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
			getItem(
				ROUTERS.BBM1_01(ROUTERS.SUB_FOREIGN_NOTICE_INQUIRY_BOARD),
				RoutesCodeEnum.BBM1_01,
				<img src={Images.iconDisc} className="w-1.5 h-1.5" />
			),
		]
	),
];

const getProfileMenuItems = () => [
	getItem(
		ROUTERS.MP1_01,
		RoutesCodeEnum.MP1_01,
		<img src={Images.iconProfile} />
	),
];

export const getMenuItems = (key: string) => {
	const newKey = getFirstPathnameSegment(key);
	switch (newKey) {
		case ROUTERS.SYSTEM:
			return getSystemMenuItems();
		case ROUTERS.WORKER:
			return getWorkerMenuItems();
		case ROUTERS.FOREIGN:
			return getForeignMenuItems();
		case ROUTERS.MP1_01:
			return getProfileMenuItems();
		default:
			break;
	}
};

const getFirstPathnameSegment = (key: string) => {
	const newKey = key.split('/')[1];
	if (isNotNilOrEmpty(newKey)) {
		return '/' + newKey;
	}
	return key;
};

export const defaultSelectedKeys = [ROUTERS.UM1_01, ROUTERS.ED1_01];

export const getMenuMobileItems = () => [
	getItemMobile(ROUTERS.AR1_01, RoutesNameEnum.AR1_01, ImagesMobile.iconWorker),
	getItemMobile(
		ROUTERS.FR1_01,
		RoutesNameEnum.FR1_01,
		ImagesMobile.iconBusinessSite
	),
	getItemMobile(
		ROUTERS.RM1_01,
		RoutesNameEnum.RM1_01,
		ImagesMobile.iconReferrer
	),
	getItemMobile(
		ROUTERS.LM1_01,
		RoutesNameEnum.LM1_01,
		ImagesMobile.iconLodging
	),
	getItemMobile(
		ROUTERS.DM1_01,
		RoutesNameEnum.DM1_01,
		ImagesMobile.iconDocument
	),
];

export type TItemMenuMobile = {
	key: string;
	label: string;
	icon: string;
};
